import React from "react";
import Footer from "../components/Footer/Footer";

import Headline from "../components/Headline/Headline";
import Navbar from "../components/Navbar/Navbar";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

import "./css/privacypolicy.css";

function PrivacyPolicy() {
  const particlesInit = async (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };

  return (
    <div className="privacy-policy">
      <ScrollToTop />
      <Headline />
      <Navbar />

      <div className="privacy-main">
        <div className="privacy-sidebar">
          <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              fullScreen: {
                enable: false,
                zIndex: 0
              },
              particles: {
                number: {
                  value: 50,
                  density: {
                    enable: true,
                    value_area: 2000
                  }
                },
                color: {
                  value: "#fff"
                },
                shape: {
                  type: "circle"
                },
                opacity: {
                  value: 0.5,
                  random: true,
                  anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                  }
                },
                size: {
                  value: 18,
                  random: true,
                  anim: {
                    enable: false,
                    speed: 40,
                    size_min: 0.1,
                    sync: false
                  }
                },
                line_linked: {
                  enable: false,
                  distance: 500,
                  color: "#ffffff",
                  opacity: 0.4,
                  width: 2
                },
                move: {
                  enable: true,
                  speed: 2,
                  direction: "top-right",
                  random: false,
                  straight: false,
                  out_mode: "out",
                  attract: {
                    enable: false,
                    rotateX: 600,
                    rotateY: 1200
                  }
                }
              },
              interactivity: {
                events: {
                  onhover: {
                    enable: true,
                    mode: "bubble"
                  },
                  onclick: {
                    enable: true,
                    mode: "repulse"
                  },
                  resize: true
                },
                modes: {
                  grab: {
                    distance: 400,
                    line_linked: {
                      opacity: 0.5
                    }
                  },
                  bubble: {
                    distance: 400,
                    size: 4,
                    duration: 0.3,
                    opacity: 1,
                    speed: 3
                  },
                  repulse: {
                    distance: 200
                  },
                  push: {
                    particles_nb: 4
                  },
                  remove: {
                    particles_nb: 2
                  }
                }
              },
              retina_detect: true,
              background: {
                color: "#2e3092",
                image: "",
                position: "50% 50%",
                repeat: "no-repeat",
                size: "cover"
              }
            }}
          />
          <h1>Privacy Policy </h1>
        </div>
        <div className="privacy-policy1">
          <div className="hding212"> Privacy Policy for Waymark Enterprises Private Limited</div>
          {/* <div className="ppp212"></div> */}
          <div className="ppp2121">
            At stocktick, accessible from https://stocktick.in/, one of our main priorities is the
            privacy of our visitors. This Privacy Policy document contains types of information that
            is collected and recorded by stocktick and how we use it.
            <br /> <br />
            If you have additional questions or require more information about our Privacy Policy,
            do not hesitate to contact us.
            <br /> <br />
            This Privacy Policy applies only to our online activities and is valid for visitors to
            our website with regards to the information that they shared and/or collect in
            stocktick. This policy is not applicable to any information collected offline or via
            channels other than this website.
            <br /> <br />
            Name, email address, phone number, etc. may be collected. Users authorize Stocktick to
            send SMS, RCS, WhatsApp, Email, and other communications. This authorization supersedes
            any registration under NDNC or DND lists as per TRAI regulations.
          </div>

          <div className="hgtr212">
            <div className="hdddder212">
              1. <span>Consent</span>
            </div>
            <div className="content212">
              By using our website, you hereby consent to our Privacy Policy and agree to its terms.
            </div>

            <div className="hdddder212">
              2. <span>Information we collect</span>
            </div>

            <div className="content212">
              The personal information that you are asked to provide, and the reasons why you are
              asked to provide it, will be made clear to you at the point we ask you to provide your
              personal information.
              <br /> <br />
              If you contact us directly, we may receive additional information about you such as
              your name, email address, phone number, the contents of the message and/or attachments
              you may send us, and any other information you may choose to provide.
              <br /> <br />
              When you register for an Account, we may ask for your contact information, including
              items such as name, company name, address, email address, and telephone number.
            </div>

            <div className="hdddder212">
              3. <span>How we use your information</span>
            </div>

            <div className="content212">
              We use the information we collect in various ways, including to:
              <br />
              <li>Provide, operate, and maintain our website </li>
              <li>Improve, personalize, and expand our website</li>
              <li>Understand and analyze how you use our website</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>
                Communicate with you, either directly or through one of our partners, including for
                customer service, to provide you with updates and other information relating to the
                website, and for marketing and promotional purposes
              </li>
              <li>Send you emails</li>
              <li>Find and prevent fraud</li>
              <br />
              Name, email address, phone number, etc. may be collected. Users authorize Stocktick to
              send SMS, RCS, WhatsApp, Email, and other communications. This authorization
              supersedes any registration under NDNC or DND lists as per TRAI regulations.
            </div>

            <div className="hdddder212">
              4. <span>Sharing of Information with Third Parties</span>
            </div>

            <div className="content212">
              We may share your personal information with trusted third-party service providers only
              for the purpose of providing our services. These may include:
              <br />
              <li>Meta (WhatsApp Business Platform)</li>
              <li>CRM providers</li>
              <li>Website hosting providers</li>
              <li>Analytics providers (such as Google Analytics)</li>
              <li>Payment service providers (where applicable)</li>
              <br />
              We do not sell or rent your personal information. Information is shared only where
              necessary to provide our services or comply with legal requirements.
            </div>

            <div className="hdddder212">
              5. <span>WhatsApp Communication Consent</span>
            </div>

            <div className="content212">
              By submitting your phone number through our website or enquiry forms, you consent to
              receive transactional, service-related, support, and promotional communications from
              Waymark Enterprises Private Limited (Stocktick Capital) via WhatsApp, SMS, Email, or
              Phone Calls.
              <br />
              <br />
              You may withdraw your consent at any time.
            </div>

            <div className="hdddder212">
              6. <span>Opt-Out of Communications</span>
            </div>

            <div className="content212">
              You can stop receiving promotional communications at any time by:
              <br />
              <li>Replying STOP on WhatsApp</li>
              <li>Contacting our support team</li>
              <li>Sending us an email requesting removal from our communication list</li>
              <br />
              We will process your request within a reasonable time.
            </div>

            <div className="hdddder212">
              7. <span>Data Retention</span>
            </div>

            <div className="content212">
              We retain your personal information only for as long as necessary to provide our
              services, comply with legal obligations, resolve disputes, and enforce our agreements.
              Once no longer required, the information is securely deleted or anonymized.
            </div>

            <div className="hdddder212">
              8. <span>Data Security</span>
            </div>

            <div className="content212">
              We use appropriate technical and organizational security measures to protect your
              personal information from unauthorized access, disclosure, misuse, or loss. These
              measures include secure servers, access controls, and encryption where applicable.
            </div>

            <div className="hdddder212">
              9. <span>Compliance with Applicable Laws</span>
            </div>

            <div className="content212">
              Waymark Enterprises Private Limited (Stocktick Capital) complies with applicable
              Indian data protection laws, TRAI regulations, and Meta&#39;s WhatsApp Business
              Platform requirements while processing personal information.
            </div>

            <div className="hdddder212">
              10. <span>Log Files</span>
            </div>

            <div className="content212">
              Stocktick follows a standard procedure of using log files. These files log visitors
              when they visit websites. All hosting companies do this and a part of hosting services
              analytics. The information collected by log files include internet protocol (IP)
              addresses, browser type, Internet Service Provider (ISP), date and time stamp,
              referring/exit pages, and possibly the number of clicks. These are not linked to any
              information that is personally identifiable. The purpose of the information is for
              analyzing trends, administering the site, tracking users movement on the website, and
              gathering demographic information.
            </div>

            <div className="hdddder212">
              11. <span>Cookies and Web Beacons</span>
            </div>

            <div className="content212">
              Like any other website, stocktick uses cookies&#39;. These cookies are used to store
              information including visitors&#39; preferences, and the pages on the website that the
              visitor accessed or visited. The information is used to optimize the users&#39;
              experience by customizing our web page content based on visitors&#39; browser type
              and/or other information.
            </div>

            <div className="hdddder212">
              12. <span> Advertising Partners Privacy Policies</span>
            </div>

            <div className="content212">
              You may consult this list to find the Privacy Policy for each of the advertising
              partners of stocktick.
              <br />
              <br />
              Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or
              Web Beacons that are used in their respective advertisements and links that appear on
              stocktick, which are sent directly to users&#39; browser. They automatically receive
              your IP address when this occurs. These technologies are used to measure the
              effectiveness of their advertising campaigns and/or to personalize the advertising
              content that you see on websites that you visit.
              <br />
              <br />
              Note that stocktick has no access to or control over these cookies that are used by
              third-party advertisers.
            </div>

            <div className="hdddder212">
              13. <span> Third Party Privacy Policies </span>
            </div>

            <div className="content212">
              Stocktick&#39;s Privacy Policy does not apply to other advertisers or websites. Thus,
              we are advising you to consult the respective Privacy Policies of these third-party ad
              servers for more detailed information. It may include their practices and instructions
              about how to opt-out of certain options.
              <br />
              <br />
              You can choose to disable cookies through your individual browser options. To know
              more detailed information about cookie management with specific web browsers, it can
              be found at the browsers&#39; respective websites.
            </div>

            <div className="hdddder212">
              14. <span>CCPA Privacy Rights (Do Not Sell My Personal Information)</span>
            </div>

            <div className="content212">
              Under the CCPA, among other rights, California consumers have the right to:
              <br />
              <br />
              Request that a business that collects a consumer&#39;s personal data disclose the
              categories and specific pieces of personal data that a business has collected about
              consumers.
              <br />
              <br />
              Request that a business delete any personal data about the consumer that a business
              has collected.
              <br />
              <br />
              Request that a business that sells a consumer&#39;s personal data, not sell the
              consumer&#39;s personal data.
              <br />
              <br />
              If you make a request, we have one month to respond to you. If you would like to
              exercise any of these rights, please contact us.
            </div>

            <div className="hdddder212">
              15. <span>GDPR Data Protection Rights</span>
            </div>

            <div className="content212">
              We would like to make sure you are fully aware of all of your data protection rights.
              Every user is entitled to the following:
              <br />
              <br />
              The right to access – You have the right to request copies of your personal data. We
              may charge you a small fee for this service.
              <br />
              <br />
              The right to rectification – You have the right to request that we correct any
              information you believe is inaccurate. You also have the right to request that we
              complete the information you believe is incomplete.
              <br />
              <br />
              The right to erasure – You have the right to request that we erase your personal data,
              under certain conditions. The right to restrict processing – You have the right to
              request that we restrict the processing of your personal data, under certain
              conditions.
              <br />
              <br />
              The right to object to processing – You have the right to object to our processing of
              your personal data, under certain conditions.
              <br />
              <br />
              The right to data portability – You have the right to request that we transfer the
              data that we have collected to another organization, or directly to you, under certain
              conditions. If you make a request, we have one month to respond to you. If you would
              like to exercise any of these rights, please contact us.
            </div>

            <div className="hdddder212">
              <span>Contact for Privacy Queries</span>
            </div>

            <div className="content212">
              If you have any questions regarding this Privacy Policy, please contact us:
              <br />
              <br />
              Waymark Enterprises Private Limited (Stocktick Capital)
              <br />
              Website:{" "}
              <a href="https://stocktick.in" target="_blank" rel="noopener noreferrer">
                https://stocktick.in
              </a>
              <br />
              Email: <a href="mailto:info@stocktick.in">info@stocktick.in</a>
              <br />
              Phone: <a href="tel:+918828306812">+91 8828306812</a>
            </div>

            <div className="hdddder212">
              16. <span>Children&#39;s Information</span>
            </div>

            <div className="content212">
              Another part of our priority is adding protection for children while using the
              internet. We encourage parents and guardians to observe, participate in, and/or
              monitor and guide their online activity.
              <br />
              <br />
              Stocktick does not knowingly collect any Personal Identifiable Information from
              children under the age of 13. If you think that your child provided this kind of
              information on our website, we strongly encourage you to contact us immediately and we
              will do our best efforts to promptly remove such information from our records.
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
